// import { store } from '../../index';
// import { setFullUserDispatcher } from '../../actions/authActions';

class UserLocalService {
  static setUser(user) {
    const updatedRoleUser = UserLocalService.handleRoleCase(user);
    const oldUser = UserLocalService.getUser();
    const res = localStorage.setItem('user', JSON.stringify({ ...oldUser, ...updatedRoleUser }));
    return res;
  }

  static getUser() {
    const res = localStorage.getItem('user');
    return JSON.parse(res);
  }

  static async updateUser(user) {
    const updatedRoleUser = UserLocalService.handleRoleCase(user);
    let resOldUserObject = await UserLocalService.getUser();
    resOldUserObject = {
      ...resOldUserObject,
      ...updatedRoleUser,
    };
    await UserLocalService.setUser(resOldUserObject);
    return resOldUserObject;
  }

  // Identity returns 'role' key when one role, and 'roles' key when more than one role.
  // However, we only use 1 role in this project, so we have to handle this and normalize.
  static handleRoleCase(user) {
    const newUser = user;
    if (Object.prototype.hasOwnProperty.call(newUser, 'role') && newUser.role.length > 1) {
      const { role } = newUser;
      if (role.indexOf('Administrator') > -1) {
        newUser.role = 'Administrator';
      } else if (role.indexOf('Manager') > -1) {
        newUser.role = 'Manager';
      } else if (role.indexOf('Appraiser') > -1) {
        newUser.role = 'Appraiser';
      }
    }
    return newUser;
  }

  static getNamesFromListById(list, id) {
    let names = '';
    if (list) {
      list.forEach((userObj) => {
        if (userObj.id === id) {
          names = `${userObj.firstName} ${userObj.lastName}`;
        }
      });
    }
    return names;
  }

  static setAccessToken(token) {
    const user = UserLocalService.getUser();
    user.accessToken = token;
    UserLocalService.setUser(user);
    return user;
  }

  static getAccessToken() {
    const user = UserLocalService.getUser();
    return user.accessToken;
  }

  static setRefreshToken(token) {
    const user = UserLocalService.getUser();
    user.refreshToken = token;
    UserLocalService.setUser(user);
    return user;
  }

  static getRefreshToken() {
    const user = UserLocalService.getUser();
    return user.refreshToken;
  }

  static isAuthenticated() {
    const user = UserLocalService.getUser();
    if (user?.accessToken) {
      return true;
    }
    return false;
  }

  static logout() {
    const user = UserLocalService.getUser();
    user.isAuthenticated = false;
    UserLocalService.setUser(user);
    return user;
  }
}

export default UserLocalService;
